import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { Button } from 'antd';

import styles from './stylesSortingTable.module.css';
import TopLeaguesRow from './CategoryRow/TopLeaguesRow';
import cashIcon from '../../../../../assets/images/cash.png';
import coinIcon from '../../../../../assets/images/coin.png';

const SortingTable = ({
  columns,
  data,
  setData,
  toggleStatus,
  removeGame,
  setRemovingGameData,
  etype,
  allGames,
  addGameInTopLeagueEntity,
  toggleTopLeagueEntityStatus,
  changeTopLeagueEntityOrder,
  EditGameIcon,
  onTogglePin,
  betAmountType,
  onBetAmountTypeChange,
  onLeagueExpand,
  expandingLeagues,
  rows,
}) => {
  const topLeagueGames = data;

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );

  const handleDragEnd = async (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = topLeagueGames.findIndex((c) => c.id === active.id);
      const newIndex = topLeagueGames.findIndex((c) => c.id === over.id);
      
      // Create the new array with reordered items
      const reorderedLeagues = arrayMove(topLeagueGames, oldIndex, newIndex);
      
      // Update all order numbers to reflect the new positions
      const updatedLeagues = reorderedLeagues.map((league, index) => ({
        ...league,
        order: (index + 1).toString()
      }));
      
      // Update local state first for immediate UI feedback
      setData(updatedLeagues);
      
      // Call the backend API to update the order
      await changeTopLeagueEntityOrder(updatedLeagues);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={topLeagueGames.map((c) => c.id)}
        strategy={verticalListSortingStrategy}
      >
        <table className={`${styles.sortingTable} leagues-table`}>
          <thead>
            <tr className={styles.headerRow}>
              {columns.map((column) => {
                return (
                  <th key={column} className={styles.headerCell}>
                    <div className={styles.headerCellContent}>
                      {column === 'Bets Amount' ? (
                        <div className={styles.betAmountToggle}>
                          <span className={styles.betAmountLabel}>Bets Amount</span>
                          <div className={styles.betAmountButtons}>
                            <Button
                              className={betAmountType === 'cash' ? styles.active : ''}
                              onClick={() => onBetAmountTypeChange('cash')}
                            >
                              <img src={cashIcon} alt="Cash" />
                            </Button>
                            <Button
                              className={betAmountType === 'coin' ? styles.active : ''}
                              onClick={() => onBetAmountTypeChange('coin')}
                            >
                              <img src={coinIcon} alt="Coin" />
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <span>{column}</span>
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((category, index) => (
              <TopLeaguesRow
                key={category.id}
                category={category}
                setTopLeagueGames={setData}
                order={index + 1}
                toggleStatus={toggleStatus}
                removeGame={removeGame}
                setRemovingGameData={setRemovingGameData}
                etype={etype}
                allGames={allGames}
                addGameInTopLeagueEntity={addGameInTopLeagueEntity}
                categories={data}
                toggleTopLeagueEntityStatus={toggleTopLeagueEntityStatus}
                changeTopLeagueEntityOrder={changeTopLeagueEntityOrder}
                EditGameIcon={EditGameIcon}
                onTogglePin={onTogglePin}
                onLeagueExpand={onLeagueExpand}
                expandingLeagues={expandingLeagues}
                rows={rows}
                columns={columns}
                betAmountType={betAmountType}
              />
            ))}
          </tbody>
        </table>
      </SortableContext>
    </DndContext>
  );
};

export default SortingTable;
